import ApiService from './ApiService'

export const _buscarDocumento = (uuid) => {
    return ApiService.fetchData({
        url: `/rest/init/documento/${uuid}`,
        method: 'get',
    })
}
